import React, { Fragment } from "react";
import { makeStyles } from "tss-react/mui";
import { Box, Chip, Divider, Typography } from "@mui/material";
import { ChevronRightRounded, CircleRounded } from "@mui/icons-material";
import CategoriesGraph from "./CategoriesGraph";

const useStyles = makeStyles()((theme) => ({
  card: {
    flex: 1,
    height: "100%",
    overflow: "auto",
    width: "100%",
    padding: 16,
    border: "1px solid #E3F2FD",
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    boxShadow: "0 0 12px 1px rgba(191, 191, 191, 0.16)",
  },
  countChip: {
    borderRadius: 4,
    background: theme.palette.mode === "dark" ? theme.palette.background.light : "#EEE",
    fontWeight: 500,
  },
  categoryTag: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    paddingTop: 8,
    paddingBottom: 8,
    cursor: "pointer",
    borderRadius: 8,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));
function Categories({ categories }) {
  const { classes } = useStyles();
  return (
    <Box className={classes.card}>
      <Box display={"flex"} alignItems={"center"} gap={1}>
        <Typography variant="body2" color="text.secondary">
          File Categories
        </Typography>
        <Chip
          size="small"
          label={Object.keys(categories).length}
          className={classes.countChip}
        />
      </Box>
      <Box mb={2} />
      <CategoriesGraph categories={categories} />
      <Box mb={2} />
      <Box>
        {Object.keys(categories).map((category, index) => {
          return (
            <Fragment key={category}>
              <Box className={classes.categoryTag}>
                <Box display={"flex"} alignItems={"center"} gap={1}>
                  <CircleRounded sx={{ fontSize: 8, color: "#e74c3c" }} />
                  <Typography
                    fontWeight={500}
                    textOverflow={"ellipsis"}
                    overflow={"hidden"}
                    whiteSpace={"nowrap"}>
                    {category}
                  </Typography>
                </Box>
                <Box display={"flex"} alignItems={"center"} gap={0.5}>
                  <Typography>{categories[category]}</Typography>
                  <Typography>files</Typography>
                  <ChevronRightRounded sx={{ fontSize: 16 }} />
                </Box>
              </Box>
              {index !== Object.keys(categories).length - 1 && (
                <Divider sx={{ my: 0.5 }} />
              )}
            </Fragment>
          );
        })}
      </Box>
    </Box>
  );
}

export default Categories;
